
export const SEARCH_TYPES_ICONS = {
  trip: 'bus',
  trip_flight: 'plane',
  category: 'table-cells-large',
  page: 'info-circle',
  web_campaign: 'tags',
  'rolf-hotel': 'hotel',
}
